import React from "react";
import Icon from "@msi/cobalt-react/icon";
import "./InputWithIcon.css";

interface InputWithIconProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  iconName?: string;
  iconSize?: number;
  type?: string;
}

const InputWithIcon: React.FC<InputWithIconProps> = ({ 
  value, 
  onChange, 
  placeholder = "Search",
  iconName = "ic_search",
  iconSize = 19,
  type = "text",
}) => {
  return (
    <div className="input-with-icon-wrapper">
      <input
        type={type}
        className={`form-control input-with-icon-field icon-left`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Icon
        name={iconName}
        size={iconSize}
        className={`input-with-icon-icon position-left`}
      />
    </div>
  );
};

export default InputWithIcon;
